/* src/app/components/doc-viewer-new/doc-viewer.component.scss */
:host::ng-deep .mat-expansion-panel {
  background: #fff;
  border: none;
  border-bottom: 1px solid #b8b8b8;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
:host::ng-deep .mat-expansion-panel.mat-expanded {
  overflow: visible;
}
:host::ng-deep .mat-expansion-panel:not([class*=mat-elevation-z]) {
  box-shadow: none;
}
:host::ng-deep .mat-accordion .mat-expansion-panel:first-of-type,
:host::ng-deep .mat-accordion .mat-expansion-panel:last-of-type {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
:host-context(.dark-theme) ::ng-deep .mat-expansion-panel {
  background: #2e2e2e;
  border: none;
  border-bottom: 1px solid #5b5b5b;
}
:host-context(.dark-theme) ::ng-deep .mat-expansion-panel:not([class*=mat-elevation-z]) {
  box-shadow: none;
}
:host-context(.dark-theme) ::ng-deep .mat-accordion .mat-expansion-panel:first-of-type,
:host-context(.dark-theme) ::ng-deep .mat-accordion .mat-expansion-panel:last-of-type {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
lex-file-compare {
  overflow: auto;
}
iframe {
  flex: auto;
  border: 0px;
}
.mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled):not(.mat-mdc-option-multiple) {
  background-color: rgba(0, 0, 0, 0.06);
}
.mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text {
  color: var(--palette-primary-default);
}
:host {
  --radio-button___margin-top: 5px;
}
.tool-bar-right {
  display: flex;
  font-size: medium;
}
.tool-bar-right > * {
  margin-left: 35px;
}
.main-tab-frame-title {
  text-align: center;
  margin: 5px;
}
.main-tab-button {
  display: block;
  margin: 5px auto;
}
.no-wrap-first-col-table > tr > td:first-child {
  white-space: nowrap;
}
.hits-repeater {
  font-size: 11px;
  font-family: Tahoma;
  height: auto;
  display: flex;
  margin-left: 10px;
}
.grip-handle {
  width: 10px;
  background: transparent;
  margin-right: -10px;
  height: 100%;
  cursor: ew-resize;
  float: right;
  z-index: 1;
}
.disable-mouse-events {
  pointer-events: none;
}
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}
/*# sourceMappingURL=doc-viewer.component.css.map */
